import { API_BASE_URL } from "utils/constants";

const AuthenPaths = {
  Login: `${API_BASE_URL}/auth/login`,

  Info: `${API_BASE_URL}/auth/user`,

  Signup: `${API_BASE_URL}/auth/register`,

  Forgot: `${API_BASE_URL}/auth/forgot-password`,

  Reset: `${API_BASE_URL}/auth/reset-password`,

  CheckUserName: `${API_BASE_URL}/auth/check-username`
};

export default AuthenPaths;
